import React, { useState, useEffect } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import { getPaymentBaseurl, toBinary } from "../../../../_helpers";
import { useRef } from "react";
import axios from "axios";

const ReplyModal = ({
  revulsionModalStatus,
  setRevulsionModalStatus,
  getByIdRepliesCollectionHandler,
  fetchUserForumPosts,
  studentPurchasedCourseDetails,
  setNestedRepliesCollection,
  forumAskQueryActionHandler,
  userAskQuestionsModalPopup,
  forumId,
  cId,
  setForumId,
}) => {
  const { REACT_APP_PAYMENT_API_BASEURL } = process.env;
  const InitialValue = {
    courseId: "",
    title: "",
    description: "",
    mediaLink: "",
  };

  const fileInputRef = useRef();
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const currentUrl = window.location.href;

  const [fileNameSet, setfileNameSet] = useState("");

  const [forumCreateDetails, setForumCreateDetails] = useState(InitialValue);
  const [postResponseStatus, setPostResponseStatus] = useState({
    postStatus: false,
    postResponseMessage: "",
  });
  const [isloading, setIsLoading] = useState(false);

  const formumSubmitHandler = () => {
    setIsLoading(true);

    if (revulsionModalStatus?.isEdit) {
      if (
        forumCreateDetails.title !== "" &&
        forumCreateDetails.description !== ""
      ) {
        axiosInstance
          .put(
            `${getPaymentBaseurl(currentUrl, true)}/forum/${
              revulsionModalStatus?.currentForumsIndexId
            }`,
            forumCreateDetails
          )
          .then((res) => {
            if (res?.data?.message) {
              setPostResponseStatus({
                ...postResponseStatus,
                postStatus: true,
                postResponseMessage: res.data.message,
              });
              setForumCreateDetails({
                courseId: "",
                title: "",
                description: "",
                mediaLink: "",
              });
              fetchUserForumPosts();
              if (revulsionModalStatus?.currentState === "levelOne") {
                getByIdRepliesCollectionHandler(
                  revulsionModalStatus.previousPostId
                );
              } else if (revulsionModalStatus?.currentState === "levelTwo") {
                setNestedRepliesCollection(revulsionModalStatus.previousPostId);
              }
            }
            if (res?.data?.error === true) {
              setError(true);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      } else {
        setErrorMsg("*Please fill all the fields.");
        setIsLoading(false);
      }
    } else {
      if (
        forumCreateDetails.description !== "" &&
        forumCreateDetails.title !== ""
      ) {
        axiosInstance
          .post(
            `${getPaymentBaseurl(currentUrl, true)}/forum`,
            forumCreateDetails
          )
          .then((res) => {
            if (res?.data?.message) {
              setPostResponseStatus({
                ...postResponseStatus,
                postStatus: true,
                postResponseMessage: res?.data?.message,
              });
              if (revulsionModalStatus?.currentState === "levelOne") {
                getByIdRepliesCollectionHandler(
                  revulsionModalStatus?.previousPostId
                );
              } else if (revulsionModalStatus?.currentState === "levelZero") {
                fetchUserForumPosts();
                getByIdRepliesCollectionHandler(revulsionModalStatus?.threadId);
              }
              fetchUserForumPosts();
            }
            if (res?.data?.error === true) {
              setError(true);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      } else {
        setErrorMsg("*Please fill all the fields.");
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (revulsionModalStatus?.isEdit) {
      const { forumsCourseId, forumsDescription, forumsTitle } =
        revulsionModalStatus;
      forumCreateDetails["threadId"] = forumCreateDetails["courseId"];
      delete forumCreateDetails["courseId"];
      setForumCreateDetails({
        ...forumCreateDetails,
        threadId: forumsCourseId,
        description: forumsDescription,
        title: forumsTitle,
      });
    } else if (!revulsionModalStatus?.isEdit) {
      forumCreateDetails["threadId"] = forumCreateDetails["courseId"];
      delete forumCreateDetails["courseId"];
      setForumCreateDetails({
        ...forumCreateDetails,
        threadId: revulsionModalStatus?.threadId,
        title: revulsionModalStatus?.forumsTitle,
      });
    }
  }, [revulsionModalStatus]);

  const forumHandleChange = (e) => {
    if (e.target.name === "courseId") {
      var selectedOption = e.target.selectedOptions[0];
      setForumCreateDetails({
        ...forumCreateDetails,
        title: selectedOption.text,
        courseId: e.target.value,
      });
    } else {
      setForumCreateDetails({
        ...forumCreateDetails,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleCreateForum = () => {
    if (
      revulsionModalStatus?.isEdit === true &&
      revulsionModalStatus?.conceal === true
    ) {
      axiosInstance.put(
        `${getPaymentBaseurl(currentUrl, true)}/forum/${
          revulsionModalStatus?.currentForumsIndexId
        }`,
        forumCreateDetails
      );
    } else {
      axiosInstance
        .post(
          `${getPaymentBaseurl(currentUrl, true)}/forum`,
          forumCreateDetails
        )
        .then((res) => {
          setForumId(res?.data?.data?.id);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const handleFileUpload = (e) => {
    axiosInstance
      .post(
        `${getPaymentBaseurl(currentUrl, true)}/${forumId}/start-multipart`,
        {
          courseId: forumCreateDetails.courseId || cId,
          forumId: forumId,
          fileName: e.target.value.substr(12, e.target.value.length),
        }
      )
      .then(({ data }) => {
        if (data) {
          sendUrl(
            data.data.signedUrl.signedUrl,
            fileInputRef.current.files[0],
            data.data.signedUrl.objectKey,
            data.data.id
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });

    setfileNameSet(e.target.value.substr(12, e.target.value.length));
  };

  const sendUrl = async (url, file, objectKey, id) => {
    return toBinary(file)
      .then((binaryFile) => {
        return axios.put(url, binaryFile.blob).then((response) => {
          CompleteMultipart(response.headers.etag, objectKey, id);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const CompleteMultipart = (etag, objectKey, id) => {
    axiosInstance
      .post(
        `${getPaymentBaseurl(
          currentUrl,
          true
        )}/forum/${forumId}/complete-multipart/${id}`,
        {
          eTag: etag.replace(/["\\]/g, ""),
          objectKey: objectKey,
        }
      )
      .then((res) => {
        forumCreateDetails["threadId"] = forumCreateDetails["courseId"];
        delete forumCreateDetails["courseId"];
        setForumCreateDetails({
          ...forumCreateDetails,
          threadId: id,
          description: forumCreateDetails.description,
          title: forumCreateDetails.title,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div
        className={
          !userAskQuestionsModalPopup
            ? "forms-reply-modal add-reply-modal"
            : "forms-width-reply add-reply"
        }
      >
        {postResponseStatus.postStatus && (
          <div className="submission_PopUp">
            <div
              className="preview-close"
              onClick={() =>
                userAskQuestionsModalPopup
                  ? forumAskQueryActionHandler()
                  : setRevulsionModalStatus({
                      ...revulsionModalStatus,
                      conceal: false,
                    })
              }
            >
              <div>
                <i className="icon check"></i>
              </div>
            </div>
            <div className="item-popup-text">
              <img
                src={
                  error
                    ? "https://cdn.edusity.com/icons/icon-failure-check.svg"
                    : "https://cdn.edusity.com/icons/icon-complete-check.svg"
                }
                alt="check-complete"
              />
              <p> {postResponseStatus.postResponseMessage}</p>
            </div>
          </div>
        )}

        {!postResponseStatus.postStatus && (
          <>
            <div className="dashboard-container-reply padding-custom-dashboard-reply">
              {!userAskQuestionsModalPopup && (
                <p>Replying For {forumCreateDetails.title}</p>
              )}
              {userAskQuestionsModalPopup && <p>Add Your Question</p>}
            </div>

            <div className="margin-top-new-reply margin-r-n-reply">
              <div className="box-shadow-new-01">
                <div className="form-content">
                  {/* {!modal.askQuestion && (
                    <p className="question-p">
                      Why did you decide to take this course?
                    </p>
                  )} */}
                  {userAskQuestionsModalPopup &&
                    studentPurchasedCourseDetails && (
                      <select
                        id="select-course-tab"
                        name="courseId"
                        selected={forumCreateDetails.title}
                        onChange={forumHandleChange}
                      >
                        <option selected disabled hidden>
                          Select course
                        </option>
                        {studentPurchasedCourseDetails &&
                          studentPurchasedCourseDetails.length > 0 &&
                          studentPurchasedCourseDetails.map((items) => (
                            <option
                              value={items.ID}
                              selected={
                                forumCreateDetails.title === items.CourseName
                              }
                            >
                              {items.CourseName}
                            </option>
                          ))}
                      </select>
                    )}

                  <div className="replyModal-Container">
                    <textarea
                      className="text-area-ReplyContainer"
                      name="description"
                      value={forumCreateDetails.description}
                      onChange={forumHandleChange}
                    ></textarea>
                  </div>
                  <div className="dashboard-reply">
                    <div id="reply-upload">
                      <input
                        className="inputs-reply-upload"
                        name="mediaLink"
                        value={fileNameSet}
                        placeholder="Enter url here..."
                      />
                      <input
                        className="upload-reply-button"
                        name="mediaLink"
                        type="file"
                        id="file-upload"
                        ref={fileInputRef}
                        onChange={handleFileUpload}
                      />
                      <label
                        htmlFor="file-upload"
                        className="upload-label"
                        onClick={handleCreateForum}
                      >
                        Upload
                      </label>
                    </div>
                  </div>
                  <p className="span-for-error-msg">{errorMsg}</p>
                  {!isloading && (
                    <div className="dashboard-reply justify-flex-new-reply-button">
                      <div className="margin-top-button-reply">
                        <button
                          className="cancel-btn-reply"
                          onClick={() =>
                            userAskQuestionsModalPopup
                              ? forumAskQueryActionHandler()
                              : setRevulsionModalStatus({
                                  ...revulsionModalStatus,
                                  conceal: false,
                                })
                          }
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="margin-top-button-reply">
                        {forumCreateDetails.title !== "" &&
                        forumCreateDetails.description !== "" &&
                        fileNameSet !== "" ? (
                          <button
                            className="submit-reply-btn"
                            onClick={() => formumSubmitHandler()}
                          >
                            Submit
                          </button>
                        ) : (
                          <button
                            className="submit-reply-btn-disabled"
                            disabled
                          >
                            Submit
                          </button>
                        )}
                      </div>
                    </div>
                  )}

                  {isloading && (
                    <div className="submissonLoadingContainer">
                      <Loading />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ReplyModal;
